var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"px-0 app-btn",attrs:{"color":_vm.color,"elevation":"2","large":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',{staticClass:"app-btn-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{staticClass:"px-5 flex-grow-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }